/**
 * @fileoverview Main theme JavaScript file containing core functionality for navigation,
 * mobile menu, cart operations, and custom web components.
 * @version 1.0.0
 */

"use strict";

// Helpers
//
/**
 * Detects if the current device supports touch input.
 *
 * @returns {boolean} True if device supports touch events
 */
var isTouchDevice = function() {
	return (('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0));
}

// Main Menu
//
if (isTouchDevice()) {
	var subMenuNavs = document.querySelectorAll('.has-sub-menu > a');
	subMenuNavs.forEach(function(mainMenuNav) {
		mainMenuNav.addEventListener('click', function(event) {
			if (!isTouchDevice()) {
				return;
			}

			subMenuNavs.forEach(function(item) {
				if (item === mainMenuNav) {
					return;
				}

				item.classList.remove('is-dropdown-open');
			});

			if (mainMenuNav.classList.contains('is-dropdown-open')) {
				return;
			}

			event.preventDefault();
			mainMenuNav.classList.add('is-dropdown-open');
		});
	});
}

// Menu classes based on available free space
//
var navigations = document.querySelectorAll('.navigation-menu');

navigations.forEach(function(navigation) {
	var navigationMenusTopNavs = navigation.querySelectorAll(':scope > .has-sub-menu');

	var getMenuWidth = function(element, initialWidth) {
		if (initialWidth === undefined) initialWidth = 0;
		var submenu = element && element.querySelector('.navigation-sub-menu');

		if (!submenu) {
			return initialWidth;
		}

		return getMenuWidth(submenu, initialWidth + submenu.clientWidth);
	}

	var setMenuClasses = function() {
		var windowWidth = window.innerWidth;
		navigationMenusTopNavs.forEach(function(navigationMenusTopNav) {
			if (navigationMenusTopNav.classList.contains('navigation-item-static')) {
				return;
			}

			navigationMenusTopNav.classList.remove('nav-open-left');
			var width = getMenuWidth(navigationMenusTopNav);

			if (navigationMenusTopNav.offsetLeft + width > windowWidth) {
				navigationMenusTopNav.classList.add('nav-open-left');
			}
		});
	}

	setMenuClasses();

	var resizeTimer;

	window.addEventListener('resize', function() {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function() {
			setMenuClasses();
		}, 350);
	});
});


// Mobile menu
//
var mobileMenuWrap = document.querySelector('.head-slot-nav-mobile-link-wrapper');
var mobileNavWrap = document.querySelector('.navigation-mobile-wrap');
var mobileMenuToggle = document.querySelector('.head-slot-nav-mobile-link');
var mobileMenu = document.querySelector('.mobile-menu');
var expandOnButton = mobileMenu ? mobileMenu.dataset.buttonExpand != null : false;

var setMobileMenuMaxheight = function() {
	mobileMenu.style.maxHeight = (window.innerHeight - document.querySelector('.header').getBoundingClientRect().bottom + 70) + 'px';
};

var handleMobileMenuOpen = function() {
	document.body.classList.add('mobile-menu-open');
	mobileMenuToggle.ariaExpanded = 'true';
	mobileMenu.ariaHidden = 'false';
	trapFocus(mobileMenuWrap, mobileNavWrap);
	setMobileMenuMaxheight();

	var event = new CustomEvent('mobile-menu:open');
	document.dispatchEvent(event);
}

var handleMobileMenuDismiss = function() {
	document.body.classList.remove('mobile-menu-open');
	mobileMenuToggle.ariaExpanded = 'false';
	mobileMenu.ariaHidden = 'true';
	removeTrapFocus(mobileMenuToggle);
	mobileMenu.style.maxHeight = '';

	var event = new CustomEvent('mobile-menu:close');
	document.dispatchEvent(event);
}

var isMobileMenuOpen = function() {
	return document.body.classList.contains('mobile-menu-open');
};

document.body.addEventListener('click', function(event) {
	var target = event.target;
	var mobileNav = target.closest('.navigation-mobile-item');
	var isMobileNavButton = target.classList.contains('head-slot-nav-mobile-link') || !!target.closest('.head-slot-nav-mobile-link');

	// Handle mobile menu item expand
	if (mobileNav && mobileNav.querySelector('ul')) {
		if (expandOnButton) {
			if (target.closest('.navigation-mobile-item-link-expand')) {
				mobileNav.classList.toggle('menu-item-expanded');
			}
		} else {
			event.preventDefault();
			mobileNav.classList.toggle('menu-item-expanded');
		}
	}

	// Handle mobile menu show / hide
	if (isMobileNavButton && document.body.classList.contains('mobile-menu-open')) {
		handleMobileMenuDismiss();
		return;
	}

	if (isMobileNavButton) {
		handleMobileMenuOpen();
		return;
	}

	if (isMobileMenuOpen() && !target.closest('.mobile-menu')) {
		event.preventDefault();
		handleMobileMenuDismiss();
	}
});

if (mobileMenuWrap) {
	mobileMenuWrap.addEventListener('keyup', function(event) {
		if (event.code.toUpperCase() === 'ESCAPE') {
			handleMobileMenuDismiss();
		}
	});
}

// Sidebar drawer button toggle
//
var sidebarDrawerButton = document.querySelector('.button-sidebar-drawer-open');
var sidebarDrawer = document.querySelector('.page-layout-sidebar');

var handleSidebarOpen = function() {
	document.body.classList.add('page-layout-sidebar-drawer-open');
	document.body.classList.add('overflow-hidden-tablet');
	trapFocus(sidebarDrawer, sidebarDrawer.querySelector('.page-layout-sidebar-drawer-header'));
}

var handleSidebarDismiss = function() {
	document.body.classList.remove('page-layout-sidebar-drawer-open');
	document.body.classList.remove('overflow-hidden-tablet');
	removeTrapFocus(sidebarDrawerButton);
}

var isSidebarOpen = function() {
	return document.body.classList.contains('page-layout-sidebar-drawer-open');
};

if (sidebarDrawerButton && sidebarDrawer) {
	document.body.addEventListener('click', function(event) {
		var target = event.target;

		if (target.classList.contains('js-button-sidebar-drawer-dismiss')) {
			handleSidebarDismiss();
			return;
		}

		if (target.classList.contains('button-sidebar-drawer-open')) {
			handleSidebarOpen();
			return;
		}

		if (isSidebarOpen() && !target.closest('.page-layout-sidebar')) {
			handleSidebarDismiss();
			event.preventDefault();
		}
	});

	sidebarDrawer.addEventListener('keyup', function(event) {
		if (event.code.toUpperCase() === 'ESCAPE') {
			handleSidebarDismiss();
		}
	});
}

document.addEventListener('change', function(event) {
	var parentNode = event.target.parentNode;
	if (parentNode && parentNode.classList.contains('select-custom')) {
		var select = event.target;
		var label = select.parentNode.querySelector('label');
		label.textContent = select.options[select.selectedIndex].text;
	}
});

// Review links / scroll
//
(function() {
	// Shopify app review link
	var reviewsLink = document.querySelectorAll('a[href*="#product-reviews"]');
	var reviews = document.getElementById('product-reviews');

	if (reviewsLink && reviews) {
		reviewsLink.forEach(function(link) {
			link.addEventListener('click', function() {
				reviews.expand();
			});
		});
	}

	if (window.location.hash === '#product-reviews' && reviews) {
		setTimeout(function() {
			reviews.expand();
		}, 0);

		setTimeout(function() {
			reviews.scrollIntoView();
		}, 200);
	}
})();

(function() {
	// App review links
	var appReviewLinks = document.querySelectorAll('.star-rating-badge');
	var reviews = document.getElementById('product-reviews');

	if (appReviewLinks.length > 0 && reviews) {
		appReviewLinks.forEach(function(link) {
			if (link.classList.contains('star-rating-link')) {
				return;
			}

			link.addEventListener('click', function() {
				reviews.expand();
			});
		});
	}

	if (appReviewLinks.length > 0 && !reviews) {
		appReviewLinks.forEach(function(link) {
			if (link.classList.contains('star-rating-link')) {
				return;
			}

			var parentCard = link.closest('.card-product');

			if (parentCard) {
				var anchorElement = parentCard.querySelector('.card-heading > a');
				var href = anchorElement ? anchorElement.getAttribute('href') : null;
				link.addEventListener('click', function() {
					window.location = href + '#product-reviews';
				});
			}
		});
	}
})();

// Collapsible / Expandable
//
/**
 * Custom element for collapsible/expandable content sections.
 * Commonly used for facets, filters, and accordion-style content.
 *
 * @extends {HTMLElement}
 */
if (!customElements.get('collapsible-expandable')) {
	class CollapsibleExpandable extends HTMLElement {
		/**
		 * Creates a new CollapsibleExpandable instance.
		 */
		constructor() {
			super();

			/** @type {boolean} */
			this.collapsed = false;

			/** @type {HTMLElement|null} */
			this.toggleElement = null;

			/** @type {HTMLElement|null} */
			this.list = null;

			/** @type {boolean} */
			this.listCollapsed = false;

			/** @type {HTMLElement|null} */
			this.expandListToggle = null;
		}

		/**
		 * Called when element is connected to the DOM.
		 * Sets up event listeners and initial state.
		 *
		 * @returns {void}
		 */
		connectedCallback() {
			this.collapsed = this.getAttribute('expanded') === 'false';
			this.toggleElement = this.querySelector('.facet-toggle');

			this.onToggle = this.onToggle.bind(this);
			this.toggleElement.addEventListener('click', this.onToggle);

			// Expandable list
			this.list = this.querySelector('.facet-options-list');
			this.listCollapsed = this.list && this.list.getAttribute('aria-expanded') === 'false';
			this.expandListToggle = this.querySelector('.facet-button-more');

			this.onListToggle = this.onListToggle.bind(this);

			if (this.expandListToggle) {
				this.expandListToggle.addEventListener('click', this.onListToggle);
			}
		}

		/**
		 * Called when element is disconnected from the DOM.
		 * Removes event listeners to prevent memory leaks.
		 *
		 * @returns {void}
		 */
		disconnectedCallback() {
			this.toggleElement.removeEventListener('click', this.onToggle);

			if (this.expandListToggle) {
				this.expandListToggle.removeEventListener('click', this.onListToggle);
			}
		}

		/**
		 * Handles click events on the toggle element.
		 *
		 * @param {Event} event - The click event
		 * @returns {void}
		 */
		onToggle(event) {
			event.preventDefault();
			this.handleToggle();
		}

		/**
		 * Collapses the expandable section.
		 *
		 * @returns {void}
		 */
		collapse() {
			this.setAttribute('expanded', 'false');
			this.toggleElement.setAttribute('aria-expanded', 'false');
			this.collapsed = true;
		}

		/**
		 * Expands the expandable section.
		 *
		 * @returns {void}
		 */
		expand() {
			this.setAttribute('expanded', 'true');
			this.toggleElement.setAttribute('aria-expanded', 'true');
			this.collapsed = false;
		}

		/**
		 * Toggles between collapsed and expanded states.
		 *
		 * @returns {void}
		 */
		handleToggle() {
			if (this.collapsed) {
				this.expand();
			} else {
				this.collapse();
			}
		}

		/**
		 * Handles click events on the list expand/collapse toggle.
		 *
		 * @param {Event} [event] - The click event
		 * @returns {void}
		 */
		onListToggle(event) {
			if (event) {
				event.preventDefault();
			}
			this.handleToggleList();
		}

		/**
		 * Collapses the expandable list.
		 *
		 * @returns {void}
		 */
		collapseList() {
			this.list.setAttribute('aria-expanded', 'false');
			this.expandListToggle.innerHTML = '&plus; ' + window.productsStrings.facetsShowMore;
			this.listCollapsed = true;
		}

		/**
		 * Expands the expandable list.
		 *
		 * @returns {void}
		 */
		expandList() {
			this.list.setAttribute('aria-expanded', 'true');
			this.expandListToggle.innerHTML = '&minus; ' + window.productsStrings.facetsShowLess;
			this.listCollapsed = false;
		}

		/**
		 * Toggles between collapsed and expanded list states.
		 *
		 * @returns {void}
		 */
		handleToggleList() {
			if (this.listCollapsed) {
				this.expandList();
			} else {
				this.collapseList();
			}
		}
	}

	customElements.define('collapsible-expandable', CollapsibleExpandable);
}

// Generic Modal Dialog
//
if (!customElements.get('modal-dialog')) {
	class ModalDialog extends HTMLElement {
		constructor() {
			super();
			var self = this;
			this.querySelector('[id^="ModalClose-"]').addEventListener(
				'click',
				this.hide.bind(this)
			);
			this.addEventListener('keyup', function(event) {
				if (event.code.toUpperCase() === 'ESCAPE') {
					self.hide();
				}
			});
			if (this.classList.contains('media-modal')) {
				this.addEventListener('pointerup', function(event) {
					if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) {
						self.hide();
					}
				});
			} else {
				this.addEventListener('click', function(event) {
					if (event.target.nodeName === 'MODAL-DIALOG') {
						self.hide();
					}
				});
			}
		}

		connectedCallback() {
			if (this.moved) {
				return;
			}

			this.moved = true;
			document.body.appendChild(this);
		}

		show(opener) {
			this.openedBy = opener;
			document.body.classList.add('overflow-hidden');
			this.setAttribute('open', '');
			trapFocus(this, this.querySelector('[role="dialog"]'));
			window.pauseAllMedia();
		}

		hide() {
			document.body.classList.remove('overflow-hidden');
			this.removeAttribute('open');
			removeTrapFocus(this.openedBy);
			window.pauseAllMedia();
		}
	}

	customElements.define('modal-dialog', ModalDialog);
	// Make ModalDialog2 globally available for other scripts to extend
	window.ModalDialog = ModalDialog;
}

// Global modal opener
//
if (!customElements.get('modal-opener')) {
	class ModalOpener extends HTMLElement {
		constructor() {
			super();

			var button = this.querySelector('button');
			var self = this;

			if (!button) {
				return;
			}

			button.addEventListener('click', function() {
				var modal = document.querySelector(self.getAttribute('data-modal'));
				if (modal) {
					modal.show(button);
				}
			});
		}
	}

	customElements.define('modal-opener', ModalOpener);
}

// Variations
//
class VariantSelects extends HTMLElement {
		constructor() {
			super();
			this.product = this.getProductData();

			if (!this.product.variants && !this.product.options) {
				return;
			}

			this.addEventListener('change', this.onVariantChange.bind(this));
			this.updateOptions();
			this.updateMasterId();

			this.hideOutOfStock = this.dataset.variantsVisibility === 'hide';
			this.disableOutOfStock = this.dataset.variantsVisibility === 'disable';
			this.hideSingle = this.dataset.hideSingle === 'true';
			this.formId = this.dataset.formId;
			this.optionsMap = this.getValidVariants();
			this.outOfStockOptionsMap = this.getOutOfStockVariants();

			if (this.tagName === 'VARIANT-SELECTS') {
				this.dropdowns = this.querySelectorAll('select');
				var self = this;

				this.dropdowns.forEach(function(select) {
					select.addEventListener('change', self.onDropdownChange.bind(self));
				});

				if (this.dropdowns[0] !== null) {
					this.onDropdownChange();
				}
			}

			this.updateVisibility();
		}

		onDropdownChange() {
			this.updateOptionsInDropdown(0);

			if (this.product.options.length > 1) {
				this.updateOptionsInDropdown(1);
			}

			if (this.product.options.length === 3) {
				this.updateOptionsInDropdown(2);
			}
		}

		updateOptionsInDropdown(selectorIndex) {
			var selector = this.dropdowns[selectorIndex];
			var originalValue = selector.value;
			selector.replaceChildren();

			var key = 'root';
			if (selectorIndex === 1) {
				key = this.dropdowns[0].value;
			} else if (selectorIndex === 2) {
				key = this.dropdowns[0].value + ' / ' + this.dropdowns[1].value;
			}

			var availableOptions = this.optionsMap[key];
			var outOfStockOptions = this.outOfStockOptionsMap[key];

			for (var i = 0; i < availableOptions.length; i++) {
				var option = availableOptions[i];
				var newOption = document.createElement('option');
				newOption.value = option;
				newOption.append(option);

				if (this.disableOutOfStock && outOfStockOptions && outOfStockOptions.indexOf(option) !== -1) {
					newOption.disabled = 'true';
				}

				selector.append(newOption);
			}

			if (availableOptions.indexOf(originalValue) !== -1) {
				selector.value = originalValue;
			}
		}

		getValidVariants(ignoreHideOutOfStock) {
			var optionsMap = {};
			for (var i = 0; i < this.product.variants.length; i++) {
				var variant = this.product.variants[i];

				// Make sure we don't hide the currently visited variant if it's out of stock.
				// The ignoreHideOutOfStock = true will always return only the
				// valid variants available for purchase regardless of the hide out of stock or disable
				// unavailable variants settings.
				if ((this.hideOutOfStock || ignoreHideOutOfStock) && !variant.available && this.currentVariant && this.currentVariant.id !== variant.id) {
					continue;
				}

				// Gathering values for the 1st drop-down.
				optionsMap['root'] = optionsMap['root'] || [];
				optionsMap['root'].push(variant.option1);
				optionsMap['root'] = Array.from(new Set(optionsMap['root']));

				// Gathering values for the 2nd drop-down.
				if (this.product.options.length > 1) {
					var key = variant.option1;
					optionsMap[key] = optionsMap[key] || [];
					optionsMap[key].push(variant.option2);
					optionsMap[key] = Array.from(new Set(optionsMap[key]));
				}

				// Gathering values for the 3rd drop-down.
				if (this.product.options.length === 3) {
					var key = variant.option1 + ' / ' + variant.option2;
					optionsMap[key] = optionsMap[key] || [];
					optionsMap[key].push(variant.option3);
					optionsMap[key] = Array.from(new Set(optionsMap[key]));
				}
			}

			return optionsMap;
		}

		getOutOfStockVariants() {
			// We get the actual valid variants to cross-reference them with the
			// option's map here. If a variant option is not included
			// in the following array it means it's not available.
			var validVariants = this.getValidVariants(true);

			var optionsMap = {};
			for (var i = 0; i < this.product.variants.length; i++) {
				var variant = this.product.variants[i];

				if (variant.available) {
					continue;
				}

				// Gathering values for the 1st drop-down.
				if (validVariants['root'] && validVariants['root'].indexOf(variant.option1) === -1) {
					optionsMap['root'] = optionsMap['root'] || [];
					optionsMap['root'].push(variant.option1);
					optionsMap['root'] = Array.from(new Set(optionsMap['root']));
				}

				// Gathering values for the 2nd drop-down.
				if (this.product.options.length > 1) {
					var key = variant.option1;
					if (validVariants[key] && validVariants[key].indexOf(variant.option2) === -1) {
						optionsMap[key] = optionsMap[key] || [];
						optionsMap[key].push(variant.option2);
						optionsMap[key] = Array.from(new Set(optionsMap[key]));
					}
				}

				// Gathering values for the 3rd drop-down.
				if (this.product.options.length === 3) {
					var key = variant.option1 + ' / ' + variant.option2;
					if (validVariants[key] && validVariants[key].indexOf(variant.option3) === -1) {
						optionsMap[key] = optionsMap[key] || [];
						optionsMap[key].push(variant.option3);
						optionsMap[key] = Array.from(new Set(optionsMap[key]));
					}
				}
			}

			return optionsMap;
		}

		onVariantChange() {
			this.updateOptions();
			this.updateMasterId();
			this.toggleAddButton(true, '');

			this.updatePickupAvailability();

			if (!this.currentVariant) {
				this.toggleAddButton(true, '');
				this.setUnavailable();
			} else {
				this.updateMedia();
				this.updateURL();
				this.updateVariantInput();
				this.renderProductInfo();

				var event = new CustomEvent('product:variant-change', {
					detail: {
						variant: this.currentVariant
					}
				});
				document.dispatchEvent(event);
			}
		}

		updateOptions() {
			var self = this;
			this.options = Array.from(this.querySelectorAll('select'), function(select) { return select.value; });
		}

		updateMasterId() {
			if (!this.product) {
				return null;
			}

			var self = this;
			this.currentVariant = this.getVariantData().find(function(variant) {
				return !variant.options.map(function(option, index) {
					return self.options[index] === option;
				}).includes(false);
			});
		}

		updateMedia() {
			var mediaGallery = document.getElementById('MediaGallery-' + this.dataset.section);

			if (!this.currentVariant || !this.currentVariant.featured_media) {
				return;
			}

			if (mediaGallery && mediaGallery.setActiveMedia) {
				mediaGallery.setActiveMedia(this.currentVariant.featured_media.id, mediaGallery.getAttribute('hide-variants') === 'true');
			}
		}

		updateURL() {
			if (!this.currentVariant || this.dataset.updateUrl === 'false') {
				return;
			}
			window.history.replaceState({}, '', this.dataset.url + '?variant=' + this.currentVariant.id);
		}

		updateVariantInput() {
			var productForms = document.querySelectorAll('#product-form-' + this.dataset.section + ', #product-form-installment');
			var self = this;

			productForms.forEach(function(productForm) {
				var input = productForm.querySelector('input[name="id"]');
				input.value = self.currentVariant.id;
				input.dispatchEvent(new Event('change', { bubbles: true }));
			});
		}

		updatePickupAvailability() {
			var pickUpAvailability = document.querySelector('pickup-availability');

			if (!pickUpAvailability || !pickUpAvailability.fetchAvailability) {
				return;
			}

			if (this.currentVariant && this.currentVariant.available) {
				pickUpAvailability.fetchAvailability(this.currentVariant.id);
			} else {
				pickUpAvailability.removeAttribute('available');
				pickUpAvailability.innerHTML = '';
			}
		}

		updateVisibility() {
			var self = this;
			// True only when EVERY option group has exactly one value — the
			// accumulator must participate or the reduce only tests the last key.
			var optionKeys = Object.keys(this.optionsMap);
			var hasSingleVariantAvailable = optionKeys.length > 0 && optionKeys.reduce(function(acc, key) {
				return acc && self.optionsMap[key].length === 1;
			}, true);
			var parent = this.closest('.product-variants');

			if (this.hideSingle && this.hideOutOfStock && hasSingleVariantAvailable) {
				if (parent) parent.classList.add('hidden');
			} else {
				if (parent) {
					parent.classList.add('variants-visible');
					parent.classList.remove('variants-hidden');
				}
			}
		}

		renderProductInfo() {
			var self = this;
			fetch(this.dataset.url + '?variant=' + this.currentVariant.id + '&section_id=' + this.dataset.section)
				.then(function(response) { return response.text(); })
				.then(function(responseText) {
					var priceId = 'price-' + self.dataset.section;
					var stockBadgeId = 'ProductAvailability-' + self.dataset.section;
					var html = new DOMParser().parseFromString(responseText, 'text/html')
					var priceDestination = document.getElementById(priceId);
					var priceSource = html.getElementById(priceId);
					var stockBadgeDestination = document.getElementById(stockBadgeId);
					var stockBadgeSource = html.getElementById(stockBadgeId);
					var productForm = document.getElementById('product-form-' + self.dataset.section);

					if (priceSource && priceDestination) {
						priceDestination.innerHTML = priceSource.innerHTML;
					}

					if (stockBadgeSource && stockBadgeDestination) {
						stockBadgeDestination.innerHTML = stockBadgeSource.innerHTML;
					}

					var price = document.getElementById('price-' + self.dataset.section);

					if (price) {
						price.classList.remove('visibility-hidden');
					}

					if (productForm) {
						var addButtonDestination = productForm.querySelector('[name="add"]');
						var addButtonSourceForm = html.getElementById('product-form-' + self.dataset.section);
						var addButtonSource = addButtonSourceForm ? addButtonSourceForm.querySelector('[name="add"]') : null;

						if (addButtonSource) {
							addButtonDestination.innerHTML = addButtonSource.innerHTML;
						}
					}

					self.toggleAddButton(!self.currentVariant.available, window.variantStrings.outOfStock);
					self.setSku(self.currentVariant.sku);
					self.setBarcode(self.currentVariant.barcode);

					publish(PUB_SUB_EVENTS.productVariantChange, {
						sectionId: self.dataset.section,
						html: html,
						variant: self.currentVariant,
					});
				});
		}

		setSku(sku) {
			var skuField = document.getElementById('ProductSku-' + this.dataset.section);

			if (!skuField) {
				return;
			}

			if (!sku) {
				skuField.parentNode.classList.add('visually-hidden');
				return;
			}

			skuField.parentNode.classList.remove('visually-hidden');
			skuField.textContent = sku;
		}

		setBarcode(barcode) {
			var barcodeField = document.getElementById('ProductBarcode-' + this.dataset.section);

			if (!barcodeField) {
				return;
			}

			if (!barcode) {
				barcodeField.parentNode.classList.add('visually-hidden');
				return;
			}

			barcodeField.parentNode.classList.remove('visually-hidden');
			barcodeField.textContent = barcode || '';
		}

		toggleAddButton(disable) {
			if (disable === undefined) disable = true;
			var productForm = document.getElementById('product-form-' + this.dataset.section);
			if (!productForm) {
				return;
			}

			var addButton = productForm.querySelector('[name="add"]');

			if (!addButton) {
				return;
			}

			if (disable) {
				addButton.setAttribute('disabled', 'disabled');
			} else {
				addButton.removeAttribute('disabled');
			}
		}

		setUnavailable() {
			var form = document.getElementById('product-form-' + this.dataset.section);
			var addButton = form.querySelector('[name="add"]');
			var addButtonText = form.querySelector('[name="add"] > span');
			var price = document.getElementById('price-' + this.dataset.section);
			var product = document.getElementById('Product-' + this.dataset.section);

			if (!addButton) {
				return;
			}

			addButtonText.textContent = window.variantStrings.unavailable;

			if (price) {
				price.classList.add('visibility-hidden');
			}
		}

		getProductData() {
			this.productData = this.productData || {
				options: JSON.parse(this.querySelector('[type="application/json"][data-id="product-options"]').textContent),
				variants: JSON.parse(this.querySelector('[type="application/json"][data-id="product-variants"]').textContent),
			}

			if (this.nodeName === 'VARIANT-RADIOS') {
				this.productData.swatches = JSON.parse(this.querySelector('[type="application/json"][data-id="product-swatches"]').textContent);
			}

			return this.productData;
		}

		getVariantData() {
			this.variantData = this.variantData || this.getProductData().variants;
			return this.variantData;
		}
	}

if (!customElements.get('variant-selects')) {
	customElements.define('variant-selects', VariantSelects);
}

if (!customElements.get('variant-radios')) {
	class VariantRadios extends VariantSelects {
		constructor() {
			super();

			if (this.tagName === 'VARIANT-RADIOS') {
				this.fieldsets = this.querySelectorAll('fieldset');
				var self = this;
				this.fieldsets.forEach(function(fieldset) {
					fieldset.addEventListener('change', self.onRadioChange.bind(self));
				});

				if (this.fieldsets[0] != null) {
					this.onRadioChange();
				}
			}
		}

		onRadioChange() {
			this.updateRadiosInFieldset(0);

			if (this.product.options.length > 1) {
				this.updateRadiosInFieldset(1);
			}

			if (this.product.options.length === 3) {
				this.updateRadiosInFieldset(2);
			}
		}

		getFieldsetCheckedValue(fieldset) {
			return Array.from(fieldset.querySelectorAll('input')).find(function(radio) { return radio.checked; }).value
		}

		updateRadiosInFieldset(selectorIndex) {
			var selector = this.fieldsets[selectorIndex];
			var optionName = selector.dataset.optionName;
			var originalValue = this.getFieldsetCheckedValue(selector);

			selector.replaceChildren();

			var key = 'root';
			if (selectorIndex === 1) {
				var value0 = this.getFieldsetCheckedValue(this.fieldsets[0]);
				key = value0;
			} else if (selectorIndex === 2) {
				var value0 = this.getFieldsetCheckedValue(this.fieldsets[0]);
				var value1 = this.getFieldsetCheckedValue(this.fieldsets[1]);
				key = value0 + ' / ' + value1;
			}

			var legend = document.createElement('legend');
			legend.textContent = optionName;
			selector.append(legend);

			var availableOptions = this.optionsMap[key];
			var outOfStockOptions = this.outOfStockOptionsMap[key];

			var checkFirst = false;
			if (availableOptions.indexOf(originalValue) === -1) {
				checkFirst = true;
			}

			for (var i = 0; i < availableOptions.length; i++) {
				var option = availableOptions[i];
				var id = this.dataset.section + '-' + selectorIndex + '-' + i;

				var newLabel = document.createElement('label');
				newLabel.value = option;
				newLabel.htmlFor = id;
				newLabel.textContent = option;

				if (this.nodeName === 'VARIANT-RADIOS' && this.productData.swatches && this.productData.swatches.swatches_on_products && this.productData.swatches.swatches[option] && this.productData.swatches.swatches_options && this.productData.swatches.swatches_options.indexOf(optionName) !== -1) {
					var color = this.productData.swatches.swatches[option].color;
					var image = this.productData.swatches.swatches[option].image;
					newLabel.dataset.tooltip = option;

					if (image) {
						newLabel.dataset.image = image;
						newLabel.style.backgroundImage = 'url(' + image + ')';
					} else if (color) {
						newLabel.dataset.color = color;
						newLabel.style.backgroundColor = color;
					}
				}

				var newOption = document.createElement('input');
				newOption.id = id;
				newOption.type = 'radio';
				newOption.name = optionName;
				newOption.value = option;
				newOption.setAttribute('form', this.formId);

				if (originalValue === option || checkFirst) {
					newOption.checked = true;
					checkFirst = false;
				}

				if (this.disableOutOfStock && outOfStockOptions && outOfStockOptions.indexOf(option) !== -1) {
					newOption.disabled = 'true';
				}

				selector.append(newOption);
				selector.append(newLabel);
				selector.append(document.createTextNode(' '));
			}
		}

		updateOptions() {
			var fieldsets = Array.from(this.querySelectorAll('fieldset'));
			this.options = fieldsets.map(function(fieldset) {
				return Array.from(fieldset.querySelectorAll('input')).find(function(radio) { return radio.checked; }).value;
			});
		}
	}

	customElements.define('variant-radios', VariantRadios);
}

// Product card

if (!customElements.get('product-card')) {
	class ProductCard extends HTMLElement {
		constructor() {
			super();
			this.colorSwatches = this.querySelectorAll('.card-product-color-swatch');
			this.productLinks = this.querySelectorAll('a.js-product-link');
			var self = this;

			this.colorSwatches.forEach(function(colorSwatch) {
				colorSwatch.addEventListener('click', function(event) {
					event.preventDefault();
					self.handleColorSwatchClick(colorSwatch);
				});

				colorSwatch.addEventListener('mouseover', function() {
					self.handleColorSwatchMouseOver(colorSwatch);
				});
			});
		}

		handleColorSwatchClick(colorSwatch) {
			var self = this;
			// Set the color swatch to active
			this.colorSwatches.forEach(function(x) { x.classList.remove('is-active'); });
			colorSwatch.classList.add('is-active');

			// Change all links to point to the new URL
			this.productLinks.forEach(function(productLink) {
				productLink.setAttribute('href', colorSwatch.getAttribute('href'));
			});

			// Change the image
			var variantImageTemplate = colorSwatch.querySelector('.card-media-image');
			var mainImage = this.querySelector('.card-media img:first-child');
			if (variantImageTemplate && mainImage) {
				var variantImage = variantImageTemplate.cloneNode(true);
				variantImage.classList.remove('card-variant-image');
				mainImage.replaceWith(variantImage);
			}
		}

		handleColorSwatchMouseOver(colorSwatch) {
			var image = colorSwatch.querySelector('.card-media-image');

			// Preload the image on mouseover
			if (image) {
				image.style.display = 'inline-block'
				image.setAttribute('loading', '');
			}
		}
	}

	customElements.define('product-card', ProductCard);
}

// Expandable list
//
if (!customElements.get('expandable-list')) {
	class ExpandableList extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.elements = {
				root: this.querySelector('ul'),
				expandableNavs: this.querySelectorAll('.has-sub-menu')
			};

			if (!this.elements.expandableNavs.length) {
				return;
			}

			this.elements.expandableNavs.forEach((nav) => {
				const navLink = nav.querySelector('a');
				navLink.addEventListener('click', this.onToggle.bind(this, nav));
			});
		}

		onToggle(navElement, event) {
			event.preventDefault();
			event.stopImmediatePropagation();

			const submenu = navElement.querySelector('ul');
			const closeOthers = this.getAttribute('close-others');
			const isExpanded = submenu.getAttribute('aria-expanded') === 'true';

			if (isExpanded) {
				this.onContract(navElement)
			} else {
				this.onExpand(navElement);

				if (closeOthers) {
					const closestRoot = navElement.closest('ul');
					const allSiblings = Array.from(closestRoot.querySelectorAll(':scope > .has-sub-menu'));
					const siblings = allSiblings.filter((item) => item !== navElement);
					siblings.forEach(this.onContract);
				}
			}
		}

		onExpand(element) {
			const submenu = element.querySelector('ul');
			element.classList.add('is-expanded');
			submenu.setAttribute('aria-expanded', 'true');
		}

		onContract(element) {
			const submenu = element.querySelector('ul');
			element.classList.remove('is-expanded');
			submenu.setAttribute('aria-expanded', 'false');
		}
	}

	customElements.define('expandable-list', ExpandableList);
}

// Quantity Input
//
if (!customElements.get('quantity-input')) {
	class QuantityInput extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.input = this.querySelector('input');
			this.changeEvent = new Event('change', { bubbles: true });

			const buttons = this.querySelectorAll('button');
			if (buttons.length > 0) {
				buttons.forEach(button => {
					button.addEventListener('click', this.onButtonClick.bind(this));
				});
			}
		}

		onButtonClick(event) {
			event.preventDefault();
			const previousValue = this.input.value;

			if (event.target.name === 'plus' || event.target.closest('[name="plus"]')) {
				this.input.stepUp();
			} else if (event.target.name === 'minus' || event.target.closest('[name="minus"]')) {
				this.input.stepDown();
			}

			if (previousValue !== this.input.value) {
				this.input.dispatchEvent(this.changeEvent);

				const quantityEvent = new CustomEvent('product:quantity-update', {
					detail: {
						quantity: Number(this.input.value),
					}
				});
				document.dispatchEvent(quantityEvent);
			}
		}
	}

	customElements.define('quantity-input', QuantityInput);
}

// Cart Remove Button
//
if (!customElements.get('cart-remove-button')) {
	class CartRemoveButton extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.addEventListener('click', (event) => {
				event.preventDefault();
				const cartItems = this.closest('cart-items');
				const miniCart = this.closest('mini-cart');

				if (cartItems && typeof cartItems.updateQuantity === 'function') {
					cartItems.updateQuantity(this.dataset.index, 0);
				} else if (miniCart && typeof miniCart.updateQuantity === 'function') {
					miniCart.updateQuantity(this.dataset.index, 0);
				} else {
					// Fallback: directly call the cart API
					const index = this.dataset.index;
					if (index) {
						this.updateCartItem(index, 0);
					}
				}
			});
		}

		updateCartItem(line, quantity) {
			// Direct cart update as fallback
			fetch(`${routes.cart_change_url}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body: JSON.stringify({
					line: parseInt(line),
					quantity: parseInt(quantity),
					sections: 'header-mini-cart-content,header-mini-cart-footer,header',
					sections_url: window.location.pathname
				})
			})
			.then(response => response.json())
			.then(response => {
				// Trigger a cart update event
				const event = new CustomEvent('cart:updated', { detail: response });
				document.dispatchEvent(event);

				// Try to update mini cart if it exists
				const miniCart = document.querySelector('mini-cart');
				if (miniCart && typeof miniCart.handleCartUpdate === 'function') {
					miniCart.handleCartUpdate({ response });
				}

				// Refresh the page sections if needed
				if (window.location.pathname === '/cart') {
					window.location.reload();
				}
			})
			.catch(error => {
				console.error('Error removing item from cart:', error);
			});
		}
	}

	customElements.define('cart-remove-button', CartRemoveButton);
}

// Mini Cart
//
if (!customElements.get('mini-cart')) {
	/**
	 * Custom element for managing the mini shopping cart drawer.
	 * Handles cart updates, item quantity changes, and synchronization with cart state.
	 *
	 * @extends {HTMLElement}
	 */
	class MiniCart extends HTMLElement {
		/**
		 * Creates a new MiniCart instance.
		 */
		constructor() {
			super();

			/** @type {HTMLElement|null} */
			this.drawer = null;

			/** @type {Array<{id: string, selector: string}>} */
			this.sections = [];
		}

		/**
		 * Called when element is connected to the DOM.
		 * Sets up event listeners for cart updates and drawer interactions.
		 *
		 * @returns {void}
		 */
		connectedCallback() {
			this.drawer = this.querySelector('drawer-modal');
			this.sections = this.getSectionsToRender();

			// Listen for cart updates via pub/sub
			if (window.subscribe && typeof PUB_SUB_EVENTS !== 'undefined') {
				subscribe(PUB_SUB_EVENTS.cartItemAdd, this.handleCartUpdate.bind(this));
				subscribe(PUB_SUB_EVENTS.cartUpdate, this.handleCartUpdate.bind(this));
			}

			// Listen for custom cart update events
			document.addEventListener('cart:updated', this.handleCartUpdate.bind(this));

			// Listen for drawer open events to refresh content
			if (this.drawer) {
				document.addEventListener('cart-drawer:open', () => {
					this.refreshCartContents();
				});
			}

			// Listen for quantity input changes
			this.addEventListener('change', (event) => {
				if (event.target.classList.contains('quantity-input-field')) {
					const line = event.target.dataset.index;
					const quantity = parseInt(event.target.value);
					if (line && quantity >= 0) {
						this.updateQuantity(line, quantity);
					}
				}
			});
		}

		/**
		 * Refreshes mini cart contents by fetching current cart state.
		 * Updates cart count and section HTML.
		 *
		 * @returns {void}
		 */
		refreshCartContents() {
			// Fetch current cart state and update mini cart
			fetch('/cart.js')
				.then(response => response.json())
				.then(cart => {
					this.updateCartCount(cart.item_count);
					// Always fetch sections to ensure mini cart displays correctly
					const sectionIds = this.getSectionsToRender().map(s => s.id).join(',');
					return fetch(`${window.location.pathname}?sections=${sectionIds}`)
						.then(response => response.json())
						.then(sections => {
							this.updateSectionContents({ sections, item_count: cart.item_count });
						});
				})
				.catch(error => console.error('Error refreshing cart contents:', error));
		}

		/**
		 * Handles cart update events from pub/sub system or custom events.
		 *
		 * @param {Object} event - Cart update event with optional response data
		 * @returns {void}
		 */
		handleCartUpdate(event) {
			// If the event has response data with sections, use it directly
			if (event && event.response && event.response.sections) {
				this.updateSectionContents(event.response);
				return;
			}

			// Otherwise, refresh cart contents manually
			this.refreshCartContents();
		}

		/**
		 * Gets list of section IDs and selectors to render when updating cart.
		 *
		 * @returns {Array<{id: string, selector: string}>} Array of section configurations
		 */
		getSectionsToRender() {
			return [
				{ id: 'header-mini-cart-content', selector: '#header-mini-cart-content' },
				{ id: 'header-mini-cart-footer', selector: '#header-mini-cart-footer' }
				// Removed header section - we only need to update mini cart specific sections
			];
		}

		/**
		 * Updates quantity of a cart line item.
		 *
		 * @param {number} line - Line item index (1-based)
		 * @param {number} quantity - New quantity
		 * @returns {void}
		 */
		updateQuantity(line, quantity) {
			this.enableLoading(line);

			const body = JSON.stringify({
				line: parseInt(line),
				quantity: parseInt(quantity),
				sections: this.getSectionsToRender().map(section => section.id).join(','),
				sections_url: window.location.pathname
			});

			fetch(`${routes.cart_change_url}`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Accept': 'application/json'
				},
				body
			})
			.then((response) => response.json())
			.then((response) => {
				if (response.status === 'error' || response.errors) {
					console.error('Cart update error:', response);
					const errorMessage = response.description || response.message || 'Error updating cart';
					this.showError(errorMessage, line);
				} else {
					this.updateSectionContents(response);
				}
			})
			.catch((error) => {
				console.error('Error updating cart:', error);
				this.disableLoading(line);
			});
		}

		/**
		 * Displays error message for cart operations.
		 *
		 * @param {string} message - Error message to display
		 * @param {number} [line] - Optional line item index for line-specific errors
		 * @returns {void}
		 */
		showError(message, line) {
			const errorElement = line ?
				this.querySelector(`#MiniCart-Line-item-error-${line} .cart-item-error-text`) :
				document.getElementById('mini-cart-error');

			if (errorElement) {
				errorElement.textContent = message;
				errorElement.parentElement.style.display = 'block';

				// Hide error after 5 seconds
				setTimeout(() => {
					errorElement.parentElement.style.display = 'none';
				}, 5000);
			}

			this.disableLoading(line);
		}

		/**
		 * Updates mini cart section contents with new HTML from response.
		 *
		 * @param {Object} response - Response object from cart API
		 * @param {Object.<string, string>} response.sections - Section HTML keyed by section ID
		 * @param {number} [response.item_count] - Updated cart item count
		 * @returns {void}
		 */
		updateSectionContents(response) {
			// Update mini cart sections only
			const sections = this.getSectionsToRender();

			sections.forEach((section) => {
				const sectionElement = document.querySelector(section.selector);
				if (!sectionElement || !response.sections || !response.sections[section.id]) {
					return;
				}

				// Simply replace the content of the section
				sectionElement.innerHTML = response.sections[section.id];
			});

			// Update cart count in header separately
			if (response.item_count !== undefined) {
				this.updateCartCount(response.item_count);
			}

			// Re-initialize any cart remove buttons
			this.initializeRemoveButtons();

			// Disable loading state
			this.disableLoading();
		}

		/**
		 * Renders mini cart contents and opens drawer.
		 *
		 * @param {Object} response - Response from cart add/update
		 * @returns {void}
		 */
		renderContents(response) {
			// Update the sections with the response
			if (response && response.sections) {
				this.updateSectionContents(response);
			} else if (response) {
				// If we have a direct cart response, fetch sections
				this.handleCartUpdate({ response });
			}

			// Open the drawer after updating content
			setTimeout(() => {
				if (this.drawer && !this.drawer.isOpen) {
					const toggle = document.querySelector('drawer-toggle[for="HeaderMiniCart"]');
					if (toggle) {
						toggle.open();
					}
				}
			}, 100); // Small delay to ensure content is updated
		}

		/**
		 * Updates cart count badge in header.
		 *
		 * @param {number} count - New cart item count
		 * @returns {void}
		 */
		updateCartCount(count) {
			// Update cart count in header
			const cartCountSelectors = [
				'.head-slot-cart-link-quantity',
				'.cart-link-count',
				'.cart-count-bubble',
				'.js-cart-count',
				'[data-cart-count]'
			];

			cartCountSelectors.forEach(selector => {
				const elements = document.querySelectorAll(selector);
				elements.forEach(element => {
					element.textContent = count;
					// Show/hide based on count
					if (count > 0) {
						element.style.display = '';
					} else {
						element.style.display = 'none';
					}
				});
			});
		}

		/**
		 * Enables loading state for a line item or entire cart.
		 *
		 * @param {number} [line] - Optional line item index
		 * @returns {void}
		 */
		enableLoading(line) {
			// Add loading state to the specific line item or entire mini cart
			const lineItem = line ? this.querySelector(`[data-line="${line}"]`) : this;
			if (lineItem) {
				lineItem.classList.add('loading');
			}
		}

		/**
		 * Disables loading state for a line item or entire cart.
		 *
		 * @param {number} [line] - Optional line item index
		 * @returns {void}
		 */
		disableLoading(line) {
			// Remove loading state
			const lineItem = line ? this.querySelector(`[data-line="${line}"]`) : this;
			if (lineItem) {
				lineItem.classList.remove('loading');
			}
		}

		/**
		 * Re-initializes remove buttons after content updates.
		 * Ensures buttons are properly connected to event handlers.
		 *
		 * @returns {void}
		 */
		initializeRemoveButtons() {
			// Re-initialize remove buttons after content update
			// The cart-remove-button custom elements will handle their own click events
			// Just ensure they can find the mini-cart parent
			const removeButtons = this.querySelectorAll('cart-remove-button');
			removeButtons.forEach(button => {
				// Ensure the button is connected to DOM
				if (!button.hasAttribute('data-initialized')) {
					// The connectedCallback should fire automatically for new elements
					// But we can force it if needed
					if (typeof button.connectedCallback === 'function') {
						button.connectedCallback();
					}
					button.setAttribute('data-initialized', 'true');
				}
			});
		}
	}

	customElements.define('mini-cart', MiniCart);
}

// Language & Country selectors.
//
if (!customElements.get('localization-form')) {
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				dropdown: this.querySelector('.dropdown'),
				panel: this.querySelector('.dropdown-list-wrap'),
			};

			if (this.elements.button) {
				this.elements.button.addEventListener('click', this.openSelector.bind(this));
			}

			if (this.elements.button && this.elements.panel) {
				this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
				this.elements.panel.addEventListener('focusout', this.closeSelector.bind(this));
			}

			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			const links = this.querySelectorAll('a');
			if (links.length) {
				links.forEach((item) => {
					item.addEventListener('click', this.onItemClick.bind(this));
				});
			}
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') {
				return;
			}

			if (this.elements.button.getAttribute('aria-expanded') == 'false') {
				return;
			}

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			this.elements.input.value = event.currentTarget.dataset.value;
			if (form) {
				form.submit();
			}
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			if (!this.elements || !this.elements.panel) {
				return;
			}

			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);
}

// Tabs
//
if (!customElements.get('tabs-component')) {
	class TabsComponent extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.addEventListener('click', this.handleClick.bind(this));
		}

		handleClick(event) {
			const button = event.target.closest('button[role="tab"]');
			if (!button) {
				return;
			}

			event.preventDefault();

			const tabButtons = this.querySelectorAll('button[role="tab"]');
			const tabPanels = this.parentElement.querySelectorAll('.tab-panel');

			tabButtons.forEach((button) => {
				button.classList.remove('tab-link-active');
			});

			tabPanels.forEach((panel) => {
				panel.classList.add('hidden');
			});

			button.classList.add('tab-link-active');

			const activePanel = this.parentElement.querySelector('#' + button.getAttribute('data-target'));
			if (activePanel) {
				activePanel.classList.remove('hidden');
			}
		}
	}

	customElements.define('tabs-component', TabsComponent);
}

if (!customElements.get('tabs-navigation')) {
	class TabsNavigation extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			const links = this.querySelectorAll('button');
			links.forEach((link) => {
				link.addEventListener('click', this.toggleTab.bind(this));
			});
		}

		toggleTab(event) {
			event.preventDefault();
			const currentTarget = event.currentTarget;
			const targetId = currentTarget.dataset.target;
			const target = document.getElementById(targetId);

			if (!target) {
				return;
			}

			// Remove active class from all links and hide all panels
			const links = this.querySelectorAll('button');
			const panels = document.querySelectorAll('.tabs-panel');

			links.forEach((link) => {
				link.classList.remove('tabs-nav-link-active');
			});

			panels.forEach((panel) => {
				panel.classList.add('hidden');
			});

			// Add active class to current link and show target panel
			currentTarget.classList.add('tabs-nav-link-active');
			target.classList.remove('hidden');
		}
	}

	customElements.define('tabs-navigation', TabsNavigation);
}

// Deferred media
//
if (!customElements.get('deferred-media')) {
	class DeferredMedia extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			const poster = this.querySelector('[id^="DeferredPoster-"]');
			if (!poster) {
				return;
			}

			poster.addEventListener('click', this.loadContent.bind(this));
		}

		loadContent(focus = true) {
			window.pauseAllMedia();

			if (!this.getAttribute('loaded')) {
				const content = document.createElement('div');
				content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

				this.setAttribute('loaded', true);
				const deferredElement = this.appendChild(content.querySelector('video, iframe'));

				if (focus) {
					deferredElement.focus();
				}

				if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
					// force autoplay for safari
					deferredElement.play();
				}
			}
		}
	}

	customElements.define('deferred-media', DeferredMedia);
}
// Drawers
//
if (!customElements.get('drawer-modal')) {
	class DrawerModal extends HTMLElement {
		constructor() {
			super();
			this.bodyClass = this.getAttribute('body-class');
			this.isOpen = false;
			this.eventPrefix = this.dataset.eventPrefix;

			var self = this;
			this.addEventListener('keyup', function(event) {
				if (event.code.toUpperCase() === 'ESCAPE') {
					if (self.isOpen) {
						self.close();
					}
				}
			});
		}

		open(opener) {
			this.isOpen = true;
			this.openedBy = opener;
			document.body.classList.add(this.bodyClass);
			document.body.classList.add('drawer-open');

			if (this.eventPrefix) {
				var event = new CustomEvent(this.eventPrefix + ':open');
				document.dispatchEvent(event);
			}
		}

		close() {
			this.isOpen = false;
			document.body.classList.remove(this.bodyClass);
			document.body.classList.remove('drawer-open');

			if (this.openedBy) {
				removeTrapFocus(this.openedBy);
			}

			if (this.eventPrefix) {
				var event = new CustomEvent(this.eventPrefix + ':close');
				document.dispatchEvent(event);
			}
		}
	}

	customElements.define('drawer-modal', DrawerModal);
}

if (!customElements.get('drawer-toggle')) {
	class DrawerToggle extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.toggleElement = this.querySelector('a') || this.querySelector('button');
			this.bodyClass = this.getAttribute('body-class');

			if (!this.toggleElement) {
				return;
			}

			var self = this;
			// Check for both 'for' and 'aria-controls' attributes
			var targetId = this.getAttribute('for') || this.getAttribute('aria-controls');
			if (targetId) {
				this.modal = document.getElementById(targetId);
			}

			this.toggleElement.addEventListener('click', function(event) {
				event.preventDefault();
				event.stopPropagation();
				self.toggle();
			});
		}

		toggle() {
			// Check if we should prevent opening (e.g., on cart page)
			if (this.hasAttribute('prevent-open') && this.getAttribute('prevent-open') === 'true') {
				// Follow the link instead of opening the drawer
				if (this.toggleElement && this.toggleElement.href) {
					window.location.href = this.toggleElement.href;
				}
				return;
			}

			if (!this.modal || this.modal.isOpen) {
				this.close();
			} else {
				this.open();
			}
		}

		open(opener) {
			if (opener === undefined) opener = this.toggleElement;
			this.setAttribute('open', '');
			this.toggleElement.setAttribute('aria-expanded', 'true');

			if (this.modal) {
				// If this is the mini cart drawer, refresh its contents
				if (this.getAttribute('for') === 'HeaderMiniCart' || this.getAttribute('aria-controls') === 'HeaderMiniCart') {
					const miniCart = document.querySelector('mini-cart');
					if (miniCart && typeof miniCart.refreshCartContents === 'function') {
						miniCart.refreshCartContents();
					}
				}
				this.modal.open(opener);
				trapFocus(this.modal, this.modal);
			}
		}

		close() {
			this.removeAttribute('open');
			this.toggleElement.setAttribute('aria-expanded', 'false');

			if (this.modal) {
				this.modal.close();
			}
		}
	}

	customElements.define('drawer-toggle', DrawerToggle);
}

document.body.addEventListener('click', function(event) {
	if (!document.body.classList.contains('drawer-open')) {
		return;
	}

	if (event.target.closest('.drawer')) {
		return;
	}

	if (event.target.closest('drawer-toggle')) {
		return;
	}

	// Close all drawers
	Array.from(document.querySelectorAll('.drawer')).forEach(function(drawer) {
		var dismiss = drawer.querySelector('drawer-toggle');

		if (dismiss) {
			dismiss.close();
		}
	});
});

// Focus trap
function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

var trapFocusHandlers = {};

function trapFocus(container, elementToFocus) {
	if (elementToFocus === undefined) elementToFocus = container;
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = function(event) {
		if (
			event.target !== container &&
			event.target !== last &&
			event.target !== first
		)
			return;

		document.addEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function() {
		document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function(event) {
		if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if (
			(event.target === container || event.target === first) &&
			event.shiftKey
		) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);

	elementToFocus.focus();
}

function removeTrapFocus(elementToFocus) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);

	if (elementToFocus) {
		elementToFocus.focus();
	}
}

function debounce(func, wait, immediate) {
	var timeout;

	return function executedFunction() {
		var context = this;
		var args = arguments;

		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);

		if (callNow) {
			func.apply(context, args);
		}
	};
}

function fetchConfig(type) {
	if (type === undefined) type = 'json';
	return {
		method: 'POST',
		headers: { 'Content-Type': 'application/json', 'Accept': 'application/' + type }
	};
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach(function(video) {
		video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
	});
	document.querySelectorAll('.js-vimeo').forEach(function(video) {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('video').forEach(function(video) { video.pause(); });
	document.querySelectorAll('product-model').forEach(function(model) {
		if (model.modelViewerUI) {
			model.modelViewerUI.pause();
		}
	});
}

(function() {
	// We wrap each RTE table by a specific class to allow wrapping
	document.querySelectorAll('.rte table').forEach(function(table) {
		table.outerHTML = '<div class="table-wrapper">' + table.outerHTML + '</div>';
	});
	document.querySelectorAll('.rte iframe').forEach(function(iframe) {
		// We scope the wrapping only for YouTube and Vimeo
		if (iframe.src.indexOf('youtube') !== - 1 || iframe.src.indexOf('youtu.be') !== - 1 || iframe.src.indexOf('vimeo') !== - 1) {
			iframe.outerHTML = '<div class="video-wrapper">' + iframe.outerHTML + '</div>'; // Re-set the src attribute on each iframe after page load for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791. Need to specifically target video and admin bar

			iframe.src = iframe.src;
		}
	});
})();


/*
 * Shopify Common JS
 * Source: Dawn theme
 */
if ((typeof window.Shopify) == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
	return function() {
		return fn.apply(scope, arguments);
	}
};

Shopify.setSelectorByValue = function(selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function(target, eventName, callback) {
	target.addEventListener(eventName, callback, false);
};

Shopify.postLink = function(path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);

	for(var key in params) {
		var hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
	this.countryEl         = document.getElementById(country_domid);
	this.provinceEl        = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function() {
		var value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function() {
		var value = this.provinceEl.getAttribute('data-default');
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function(e) {
		var opt       = this.countryEl.options[this.countryEl.selectedIndex];
		var raw       = opt.getAttribute('data-provinces');
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none';
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = "";
		}
	},

	clearOptions: function(selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function(selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	}
};